import { routing } from "../../routing.js";
import { Query, SortOrder } from "../../types/index.js";
import { toIso8601 } from "../../utils.js";
export function createClient(api) {
  async function list(options) {
    const {
      search,
      query,
      limit,
      offset,
      sortOrder
    } = options;
    return api.get(routing.campaignsUrl, {
      query: {
        limit,
        offset,
        search,
        query: Query.stringify(query),
        sort: SortOrder.stringify(sortOrder)
      }
    });
  }
  async function search(options) {
    const {
      search,
      query,
      limit,
      offset,
      sortOrder
    } = options;
    return api.post(routing.campaignsUrl, {
      payload: {
        limit,
        offset,
        search,
        query,
        sort: SortOrder.stringify(sortOrder)
      }
    });
  }
  async function get(id) {
    return api.get(`${routing.campaignsUrl}/${id}`);
  }
  async function duplicate(id) {
    return api.post(`${routing.campaignsUrl}/${id}/duplicate`);
  }
  async function doDelete(id) {
    return api.delete(`${routing.campaignsUrl}/${id}`);
  }
  async function test(id, emails) {
    return api.post(`${routing.campaignsUrl}/${id}/test`, {
      payload: {
        emails
      }
    });
  }
  async function send(id) {
    return api.post(`${routing.campaignsUrl}/${id}/send`);
  }
  async function schedule(id, sendAt) {
    const {
      campaign
    } = await api.post(`${routing.campaignsUrl}/${id}/schedule`, {
      payload: {
        schedule_at: toIso8601(sendAt)
      }
    });
    return campaign;
  }
  async function unschedule(id) {
    const {
      campaign
    } = await api.post(`${routing.campaignsUrl}/${id}/unschedule`);
    return campaign;
  }
  function create(payload) {
    return api.post(routing.campaignsUrl, {
      payload
    });
  }
  async function update(id, payload) {
    return api.patch(`${routing.campaignsUrl}/${id}`, {
      payload
    });
  }
  return {
    list,
    search,
    get,
    duplicate,
    test,
    send,
    schedule,
    unschedule,
    create,
    update,
    delete: doDelete
  };
}